import moment from "moment";

class PDFInvoiceReport {
    constructor() {
        this.reportData = null;
    }

    async exportToPDF(data) {
        this.reportData = data;

        await this.waitForPdfMakeReady();

        const docDefinition = this.buildDocDefinition();

        pdfMake.createPdf(docDefinition).open();
    }

    waitForPdfMakeReady() {
        return new Promise((resolve) => {
            const interval = setInterval(() => {
                if (typeof pdfMake !== "undefined" && pdfMake.fonts) {
                    clearInterval(interval);
                    resolve(true);
                }
            }, 100);
        });
    }

    formatDate(date) {
        return moment(date).format("DD/MM/YYYY");
    }

    formatNumber(value) {
        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value || 0);
    }

    // ================= HEADER =================
    buildHeader() {
        const header = this.reportData?.header || {};

        return [
            {
                columns: [
                    {
                        width: "55%",
                        stack: [
                            {
                                text: header.company_name_en || " ",
                                fontSize: 14,
                                bold: true,
                            },
                            {
                                text: header.company_name_th || " ",
                                fontSize: 11,
                                margin: [0, 2, 0, 0],
                            },
                        ],
                    },
                    {
                        width: "45%",
                        stack: [
                            {
                                text: "CONFIDENTIAL",
                                color: "red",
                                bold: true,
                                alignment: "right",
                                fontSize: 10,
                            },
                            {
                                text: "INVOICE REPORT", // 🔥 เปลี่ยนชื่อ
                                bold: true,
                                alignment: "right",
                                fontSize: 14,
                                margin: [0, 3, 0, 0],
                            },
                            {
                                text: `${this.formatDate(header.date_from)} - ${this.formatDate(header.date_to)}`,
                                alignment: "right",
                                fontSize: 9,
                                margin: [0, 2, 0, 0],
                            },
                        ],
                    },
                ],
                margin: [0, 0, 0, 10],
            },
        ];
    }

    // ================= CONTENT =================
    buildContent() {
        const content = this.reportData?.content || [];
        const result = [];

        content.forEach((section) => {

            const body = [];

            // ===== HEADER ROW =====
            body.push([
                {
                    text: section.department_name,
                    bold: true,
                    fontSize: 11,
                    margin: [0, 6, 0, 2],
                    border: [false, false, false, true],
                },
                {
                    text: "INVOICE NO.",
                    bold: true,
                    margin: [0, 6, 0, 2],
                    border: [false, false, false, true],
                },
                {
                    text: "AMOUNT",
                    bold: true,
                    alignment: "right",
                    margin: [0, 6, 0, 2],
                    border: [false, false, false, true],
                },
                {
                    text: "CUR",
                    bold: true,
                    alignment: "center",
                    margin: [0, 6, 0, 2],
                    border: [false, false, false, true],
                },
                {
                    text: "STATUS",
                    bold: true,
                    alignment: "center",
                    margin: [0, 6, 0, 2],
                    border: [false, false, false, true],
                },
            ]);

            // ===== DATA =====
            section.dates.forEach((dateGroup) => {

                // DATE
                body.push([
                    {
                        text: this.formatDate(dateGroup.date),
                        bold: true,
                        colSpan: 5,
                        margin: [0, 12, 0, 3],
                        border: [false, false, false, false],
                    },
                    {}, {}, {}, {}
                ]);

                // ITEMS
                dateGroup.items.forEach((item) => {
                    body.push([
                        {
                            text: item.client_name || "",
                            margin: [0, 1, 0, 1],
                        },
                        {
                            text: item.invoice_no || "####",
                            margin: [0, 1, 0, 1],
                        },
                        {
                            text: this.formatNumber(item.amount),
                            alignment: "right",
                            margin: [0, 1, 5, 1],
                        },
                        {
                            text: item.currency || "",
                            alignment: "center",
                        },
                        {
                            text: item.status || "",
                            alignment: "center",
                        },
                    ]);
                });
            });

            // ===== PUSH TABLE =====
            result.push({
                table: {
                    widths: ["*", 70, 70, 50, 50],
                    body: body,
                },
                layout: {
                    hLineWidth: (i) => (i === 1 ? 1 : 0),
                    vLineWidth: () => 0,
                },
                margin: [0, 10, 0, 10],
            });
        });

        return result;
    }

    // ================= DOC =================
    buildDocDefinition() {
        return {
            pageSize: "A4",
            pageMargins: [40, 40, 40, 40],

            content: [...this.buildHeader(), ...this.buildContent()],

            defaultStyle: {
                font: "Sarabun",
                fontSize: 10,
            },
        };
    }
}

export default new PDFInvoiceReport();